<template>
  <span class="cd-drill">
    <span :class="valueClasses" @click="onDrill">{{ count | number }}</span>
    <feather-icon
      v-if="count"
      icon="ExternalLinkIcon"
      size="13"
      class="cd-ext"
      v-b-tooltip.hover
      :title="$t('clientDashboard.openInNewTab')"
      @click.stop="$emit('external')"
    />
  </span>
</template>

<script>
export default {
  name: 'DrillCell',
  props: {
    count: { default: 0 },
    // When true, render the colored "chip" style (age buckets); otherwise the
    // plain clickable link style used by totals / FTD / STD cells.
    chip: { type: Boolean, default: false },
    variant: { type: String, default: '' }, // good | warn | bad
  },
  computed: {
    valueClasses() {
      if (this.chip) {
        return ['cd-chip', this.count ? `cd-chip--${this.variant}` : 'cd-chip--zero', { 'cd-clickable': this.count }];
      }
      return { 'cd-clickable cd-link': this.count };
    },
  },
  methods: {
    onDrill() {
      if (this.count) this.$emit('drill');
    },
  },
};
</script>

<style scoped lang="scss">
.cd-drill { display: inline-flex; align-items: center; gap: 5px; }
.cd-ext {
  color: #b9b9c3;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease;
}
.cd-drill:hover .cd-ext { opacity: 1; }
.cd-ext:hover { color: #007bff; }

/* Value styling — copied from ClientDashboard so the cell renders identically
   (scoped styles there don't reach this component's elements). */
.cd-chip {
  display: inline-block;
  min-width: 36px;
  padding: 2px 9px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.78rem;
}
.cd-clickable {
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;
  &:hover { transform: translateY(-1px); filter: brightness(0.97); }
}
.cd-link {
  color: #007BFF;
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
  font-weight: 700;
  &:hover { color: #0062cc; }
}
.cd-chip.cd-clickable:hover { box-shadow: 0 4px 10px -4px rgba(20, 24, 50, 0.3); }
.cd-chip--good { background: rgba(40, 199, 111, 0.14); color: #28a866; }
.cd-chip--warn { background: rgba(245, 159, 11, 0.16); color: #d98a06; }
.cd-chip--bad  { background: rgba(234, 84, 85, 0.14); color: #e0484a; }
.cd-chip--zero { background: transparent; color: #c2c7d6; font-weight: 500; }
</style>

<style scoped lang="scss">
body.dark-layout {
  .cd-chip--zero { color: #5a6377; }
  .cd-link { color: #6cb2ff; &:hover { color: #8fc6ff; } }
}
</style>
